import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { LoaderProvider } from './loader';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <LoaderProvider>
      <ToastProvider>{children}</ToastProvider>
    </LoaderProvider>
  </AuthProvider>
);

export default AppProvider;
